/**
 * BotWarning Entity Definition
 */
import { BotWarningRelationSchema } from "../schemas/relations";
import { defineEntity } from "./core";
import { getLazyBotConfigEntityDef } from "./lazy-refs";
export const BotWarningEntityDef = defineEntity({
    name: "bot-warning",
    schema: BotWarningRelationSchema,
    relations: {
        bot_config: { type: "one", entity: getLazyBotConfigEntityDef },
    },
});
